import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  loadPapersListRequested,
  storePaperRequested,
  updatePaperRequested,
  updateAssignPaperRequested,
  storeAssignPaperRequested,
  loadPaperWeekdaysRequested,
} from 'store/papers/papersSlice';

export function useStorePaper() {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const onStorePaper = useCallback(
    async (values: any, actions: any) => {
      actions.setSubmitting(true);
      await dispatch(
        storePaperRequested({
          values: {
            ...values,
            paperType: values?.paperType?.id,
          },
          navigate: navigation,
        })
      );
      setTimeout(() => {
        actions.setSubmitting(false);
      }, 1000);
    },
    [dispatch]
  );
  return { onStorePaper };
}

export function useUpdatePaper() {
  const dispatch = useDispatch();
  const onUpdatePaper = useCallback(
    async (values: any) => {
      await dispatch(
        updatePaperRequested({ ...values, paperType: values?.paperType?.id })
      );
    },
    [dispatch]
  );
  return { onUpdatePaper };
}

// export function useArchivePaper() {
//   const dispatch = useDispatch();
//   const onArchivePaper = useCallback(
//     async (id: any) => {
//       await dispatch(archivePaperRequested({ id: id }));
//     },
//     [dispatch]
//   );
//   return { onArchivePaper };
// }

export function useStoreAssignPaper(id: any) {
  const dispatch = useDispatch();

  const onStoreAssignPaper = useCallback(
    async (values: any) => {
      await dispatch(
        storeAssignPaperRequested({
          ...values,
          paperId: values?.paper?.id,
          customerReference: id,
          deliveryOption: values?.deliveryOption?.id,
        })
      );
    },
    [dispatch]
  );
  return { onStoreAssignPaper };
}

export function useUpdateAssignPaper() {
  const dispatch = useDispatch();
  const onUpdateAssignPaper = useCallback(
    async (values: any) => {
      await dispatch(
        updateAssignPaperRequested({
          ...values,
          paperId: values?.paper?.id,
          deliveryOption: values?.deliveryOption?.id,
        })
      );
    },
    [dispatch]
  );
  return { onUpdateAssignPaper };
}

// export function useArchiveAsignPaper() {
//   const dispatch = useDispatch();
//   const onArchiveAssignPaper = useCallback(
//     async (id: any) => {
//       await dispatch(archivePaperRequested({ id: id }));
//     },
//     [dispatch]
//   );
//   return { onArchiveAssignPaper };
// }

export function useLoadPapersList() {
  const dispatch = useDispatch();
  const onLoadPapersList = useCallback(async () => {
    await dispatch(loadPapersListRequested({}));
  }, [dispatch]);
  useEffect(() => {
    onLoadPapersList();
  }, [onLoadPapersList]);
  return { onLoadPapersList };
}

export function useLoadPaperWeekdays() {
  const dispatch = useDispatch();
  const onLoadPaperWeekdays = useCallback(
    async (reference: string) => {
      await dispatch(loadPaperWeekdaysRequested(reference));
    },
    [dispatch]
  );
  return { onLoadPaperWeekdays };
}
